import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";

const AllStages = [
  {
    title: "Just Starting",
  },
  {
    title: "Shortlisting",
    value: "Shortlisting Colleges",
  },
  {
    title: "Scores Ready",
    value: "Tests Done",
  },
  {
    title: "Offers Received",
    value: "Admissions Received",
  },
  {
    title: "Applied",
    value: "Applied to Colleges",
  },
];

export const Stage = ({ stage, setStage }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>
        Where are you in the application journey?
      </Title>
        <TitleCardsList
          options={AllStages}
          selectedCard={stage}
        setSelectedCard={setStage}
      />
    </Flex>
  );
};
